__turbopack_context__.v({
  "list": "Skeleton-module-scss-module__k0Jfva__list",
  "listItem": "Skeleton-module-scss-module__k0Jfva__listItem",
  "root": "Skeleton-module-scss-module__k0Jfva__root",
  "skeletonCard": "Skeleton-module-scss-module__k0Jfva__skeletonCard",
  "skeletonCardEyebrow": "Skeleton-module-scss-module__k0Jfva__skeletonCardEyebrow",
  "skeletonCardHeadline": "Skeleton-module-scss-module__k0Jfva__skeletonCardHeadline",
  "skeletonCardImage": "Skeleton-module-scss-module__k0Jfva__skeletonCardImage",
  "skeletonCardText": "Skeleton-module-scss-module__k0Jfva__skeletonCardText",
  "textFill": "Skeleton-module-scss-module__k0Jfva__textFill",
  "theme--makers-reserve": "Skeleton-module-scss-module__k0Jfva__theme--makers-reserve",
});
